import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Loadable from 'react-loadable'

import {
  LoginRoute,
  LinkRoute,
  RecoverPasswordRoute,
  ResetPasswordRoute,
  ResetPasswordNoTokenRoute,
  SetPasswordRoute,
  OnboardingBaseRoute,
  CreateOrgRoute,
  CreateUserRoute,
  MobileRoute,
  RecoverUsernameRoute,
  UnassociatedRoute,
  SingleSignOnRoute,
  SingleSignOnLinkRoute,
  TrialExpiredRoute,
} from 'resources/routes'

import Login from 'containers/login'
import Link from 'containers/link'
import Mobile from 'containers/mobile'
import RecoverPassword from 'containers/recover-password'
import ResetPassword from 'containers/reset-password'
import RecoverUsername from 'containers/recover-username'

const LoadableCreateOrg = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'createOrg' */ 'routing-containers/create-org'),
  loading: () => null,
})

const LoadableCreateUser = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'createUser' */ 'routing-containers/create-user'
    ),
  loading: () => null,
})

const LoadableSetPassword = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: 'setPassword' */ 'routing-containers/set-password'
    ),
  loading: () => null,
})

const LoadableUnassociated = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'unassociated' */ 'containers/unassociated'),
  loading: () => null,
})

const LoadableTrialExpired = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'trialExpired' */ 'containers/trial-expired'),
  loading: () => null,
})

const LoadableSingleSignOn = Loadable({
  loader: () => import(/* webpackChunkName: 'sso' */ 'containers/sso'),
  loading: () => null,
})

const LoadableSingleSignOnLink = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'sso-link' */ 'containers/sso-link'),
  loading: () => null,
})

export function getRoutes() {
  return (
    <Routes>
      <Route path={LoginRoute} element={<Login />} />
      <Route path={LinkRoute} element={<Link />} />

      <Route path={RecoverPasswordRoute} element={<RecoverPassword />} />
      <Route path={ResetPasswordRoute} element={<ResetPassword />} />
      <Route path={ResetPasswordNoTokenRoute} element={<ResetPassword />} />
      <Route path={SetPasswordRoute} element={<LoadableSetPassword />} />

      <Route path={CreateOrgRoute} element={<LoadableCreateOrg />} />
      <Route path={CreateUserRoute} element={<LoadableCreateUser />} />

      <Route path={MobileRoute} element={<Mobile />} />
      <Route path={RecoverUsernameRoute} element={<RecoverUsername />} />
      <Route path={UnassociatedRoute} element={<LoadableUnassociated />} />

      <Route path={SingleSignOnRoute} element={<LoadableSingleSignOn />} />
      <Route
        path={SingleSignOnLinkRoute}
        element={<LoadableSingleSignOnLink />}
      />

      <Route path={TrialExpiredRoute} element={<LoadableTrialExpired />} />

      <Route
        path={OnboardingBaseRoute}
        element={<Navigate to={CreateOrgRoute} replace />}
      />
      <Route
        path={`${OnboardingBaseRoute}/*`}
        element={<Navigate to={CreateOrgRoute} replace />}
      />

      <Route path='*' element={<Navigate to={LoginRoute} replace />} />
    </Routes>
  )
}
